import { render, staticRenderFns } from "./HotelGalleryModal.vue?vue&type=template&id=f8f15d32"
import script from "./HotelGalleryModal.vue?vue&type=script&lang=js"
export * from "./HotelGalleryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports